import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { styled } from '@mui/material';
import { Button, type ButtonType } from '~/components/Button';

type SocialShareButtonProps = ButtonType & {
  url: string;
  social: 'linkedin' | 'twitter';
  title: string;
  text: string;
};

export const SocialShareButton = ({
  url,
  title,
  social,
  text,
  ...buttonProps
}: SocialShareButtonProps) => {
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    title
  )}&url=${encodeURIComponent(url)}&hashtags=nerdydata&via=nerdydata`;
  const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    url
  )}&title=${encodeURIComponent(title)}&source=www.nerdydata.com`;

  const href = social === 'twitter' ? twitterUrl : linkedinUrl;

  return (
    <ShareButton
      className={`share-button ${social}-share}`}
      target="_blank"
      rel="noopener nofollow"
      href={href}
      size="small"
      variant="outlined"
      startIcon={
        <>
          {social === 'linkedin' && <LinkedInIcon />}
          {social === 'twitter' && <XIcon />}
        </>
      }
      {...buttonProps}>
      {text}
    </ShareButton>
  );
  //   </a>
};
const ShareButton = styled(Button)`
  &.twitter-share {
    background: #1b95e0;
  }

  &.linkedin-share {
    background: #2477b5;
  }
`;
